import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M878.992 867.83a508.156 508.156 0 00144.356-356.156c0-127.63-46.435-248.162-131.309-342.246l37.065-37.064 34.857 34.793a26.83 26.83 0 0038.056 0 26.99 26.99 0 000-38.087L894.31 21.362a26.959 26.959 0 00-38.088 38.088l34.858 34.794-37.064 37.064C759.932 46.434 639.368 0 511.738 0S263.544 46.434 169.46 131.308l-37.064-37.064 34.793-34.794a26.959 26.959 0 00-38.087-38.088L21.394 129.07a26.99 26.99 0 0019.06 45.954 27.119 27.119 0 0019.06-7.867l34.794-34.793 37.064 37.064A507.932 507.932 0 00.064 511.674c0 134.058 51.231 260.186 144.356 356.125L34.858 977.329a26.99 26.99 0 0019.06 46.019 26.927 26.927 0 0019.06-7.931l110.937-110.874c91.845 76.911 206.62 118.805 327.855 118.805s236.01-41.894 327.855-118.805l110.905 110.874a26.927 26.927 0 1038.088-38.088l-109.562-109.53zM53.854 511.675c0-252.415 205.373-457.756 457.82-457.756s457.82 205.34 457.82 457.756S764.12 969.43 511.674 969.43 53.854 764.089 53.854 511.674z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M764.217 437.065c-6.876-10.201-22.066-13.687-33.963-7.803L485.61 550.37 294.916 435.914c-11.225-6.748-26.767-4.381-34.602 5.245s-5.117 22.93 6.108 29.677L470.1 593.094a9.658 9.658 0 001.44.8l.287.16 1.343.639.288.128 1.535.607c.288.128.64.224.96.288.191.032.383.128.64.224l1.054.256.608.128 1.087.224c.192.032.384.096.608.096l1.055.128c.256.032.512.032.736.095.288.032.608.032.895.096a18.836 18.836 0 001.343.032h.288a27.822 27.822 0 002.846-.128h.16a26 26 0 002.687-.415l.255-.032a21.938 21.938 0 002.495-.64l.384-.128a19.955 19.955 0 002.302-.863l1.343-.608 258.364-127.886c11.896-5.885 15.957-18.932 9.114-29.102l.064-.096z"
});

function SvgAlarm(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "alarm_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), _ref, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'AlarmOutlined';

export default KuFoxIcons;
